export const mockSuppliers = [
  {
    id: '1',
    name: 'İpek Tekstil',
    phone: '0212 345 67 89',
    total_purchases: 15000,
    total_paid: 8000,
    remaining_debt: 7000,
    created_at: '2026-01-15T10:00:00Z',
  },
  {
    id: '2',
    name: 'Deri Moda',
    phone: '0216 456 78 90',
    total_purchases: 22000,
    total_paid: 12000,
    remaining_debt: 10000,
    created_at: '2026-02-01T11:00:00Z',
  },
  {
    id: '3',
    name: 'Koton Tedarik',
    phone: '0212 567 89 01',
    total_purchases: 8500,
    total_paid: 5000,
    remaining_debt: 3500,
    created_at: '2026-03-10T09:00:00Z',
  },
  {
    id: '4',
    name: 'Moda Aksesuar',
    phone: '0216 678 90 12',
    total_purchases: 6000,
    total_paid: 6000,
    remaining_debt: 0,
    created_at: '2026-04-05T14:00:00Z',
  },
  {
    id: '5',
    name: 'Zarif Giyim',
    phone: '0212 789 01 23',
    total_purchases: 18000,
    total_paid: 10000,
    remaining_debt: 8000,
    created_at: '2026-05-01T10:00:00Z',
  },
];

export const mockSupplierPurchases = [
  {
    id: '1',
    supplier_id: '1',
    purchase_date: '2026-05-15',
    product_description: 'İpek kumaş, 50 metre',
    total_amount: 8000,
    paid_amount: 3000,
    remaining_amount: 5000,
    due_date: '2026-06-15',
    status: 'Bekliyor',
    notes: 'Vade tarihi 15 Haziran',
    created_at: '2026-05-15T10:00:00Z',
  },
  {
    id: '2',
    supplier_id: '2',
    purchase_date: '2026-05-10',
    product_description: 'Deri ceket, 20 adet',
    total_amount: 12000,
    paid_amount: 7000,
    remaining_amount: 5000,
    due_date: '2026-06-10',
    status: 'Bekliyor',
    notes: '',
    created_at: '2026-05-10T11:00:00Z',
  },
  {
    id: '3',
    supplier_id: '3',
    purchase_date: '2026-05-05',
    product_description: 'Kot kumaş, 100 metre',
    total_amount: 5500,
    paid_amount: 3000,
    remaining_amount: 2500,
    due_date: '2026-06-05',
    status: 'Bekliyor',
    notes: '',
    created_at: '2026-05-05T09:00:00Z',
  },
  {
    id: '4',
    supplier_id: '1',
    purchase_date: '2026-04-20',
    product_description: 'İpek şal, 30 adet',
    total_amount: 7000,
    paid_amount: 5000,
    remaining_amount: 2000,
    due_date: '2026-05-20',
    status: 'Gecikti',
    notes: 'Vade geçti, ödeme bekleniyor',
    created_at: '2026-04-20T14:00:00Z',
  },
  {
    id: '5',
    supplier_id: '5',
    purchase_date: '2026-05-01',
    product_description: 'Yazlık elbise, 40 adet',
    total_amount: 10000,
    paid_amount: 5000,
    remaining_amount: 5000,
    due_date: '2026-06-01',
    status: 'Bekliyor',
    notes: '',
    created_at: '2026-05-01T10:00:00Z',
  },
  {
    id: '6',
    supplier_id: '4',
    purchase_date: '2026-04-10',
    product_description: 'Çanta, deri, 25 adet',
    total_amount: 6000,
    paid_amount: 6000,
    remaining_amount: 0,
    due_date: '2026-05-10',
    status: 'Kapandı',
    notes: 'Tamamlandı',
    created_at: '2026-04-10T11:00:00Z',
  },
];